/* eslint-disable react/no-did-mount-set-state */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tooltip.sass';

/*
 *  Currently only support top and bottom positioning...
 */
class Tooltip extends Component {
  constructor(props) {
    super(props);
    const state = { controlledStyle: {} };
    // const { position, offset } = props;
    // const newStyle = {};
    // const tooltipElement = this.tooltipContent;
    // const { clientWidth } = tooltipElement;

    // switch (position) {
    //   case 'top':
    //   case 'bottom':
    //     newStyle.left = '50%';
    //     newStyle.marginLeft = `-${clientWidth / 2}px`;
    //     if (offset) { newStyle[position] = `calc(-100% - ${offset}pt)`; }
    //     state.controlledStyle = newStyle;
    //     break;
    //   default:
    // }

    this.state = state;
  }

  componentDidMount() {
    const { position, offset } = this.props;
    const newStyle = {};
    const { clientWidth } = this.tooltipContent;

    switch (position) {
      case 'top':
      case 'bottom':
        newStyle.left = '50%';
        newStyle.marginLeft = `-${clientWidth / 2}px`;
        if (offset) { newStyle[position] = `calc(-100% - ${offset}pt)`; }
        break;
      default:
    }

    this.setState({ controlledStyle: newStyle });
  }

  render() {
    const {
      className,
      children,
      content,
      position,
      onClick,
      style
    } = this.props;
    return (
      <div className={`Tooltip ${className}`} onClick={onClick}>
        <span className="tooltip-trigger">{ children }</span>
        <span
          ref={(c) => { this.tooltipContent = c; }}
          style={{ ...style, ...this.state.controlledStyle }}
          className={`tooltip-info ${position}`}
        >
          { content }
        </span>
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.any.isRequired,
  content: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  offset: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
};

Tooltip.defaultProps = {
  onClick() { },
  className: '',
  offset: 0,
  style: {}
};


export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip.jsx